import React from 'react';
import { getEventUrl } from 'constants/pages';
import { ButtonLink } from 'components/Button';
import { SuccessType } from '../types';

const Success = ({ formData }: SuccessType) => {
  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center">
      <h5 className="typography-product-display mb-4">Success!</h5>

      <p className="typography-product-body mb-2 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        You can find the tournament in the{' '}
        <span className="typography-product-subheading">You tab.</span>
      </p>

      <p className="typography-product-body mb-12 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        Share your tournament link to get players signed up!
      </p>

      <ButtonLink
        href={getEventUrl(formData?.eventId)}
        variant="primary"
        className="w-full md:w-auto"
        size="lg"
      >
        View Tournament
      </ButtonLink>
    </div>
  );
};

export default Success;
